<template>
    <div class="counter">
        <input type="number" inputmode="numeric" :min="props.min" pattern="[0-9]*" placeholder="0"  data-link="#form-133" readonly v-model="currentValue" @change="onChange">
        <button v-show="canModify" type="button" role="button" id="" class="minus" @click="decrease">
            - <span class="screen-reader">{{ copydeck.accessibility.btn_decrease[lang] }}</span>
        </button>
        <button v-show="canModify" type="button" role="button" id="" class="more" @click="increase">
            + <span class="screen-reader">{{ copydeck.accessibility.btn_increase[lang] }}</span>
        </button>
    </div>
</template>

<script>
export default {
    name: "OrderCounter"
}
</script>

<script setup>

import { ref , computed } from "vue";
import {useMainStore} from "../stores/main";
import {storeToRefs}  from "pinia";

let store = useMainStore();
let { copydeck, lang } = storeToRefs(store);

const props = defineProps(["value","max", "min", "product", "groupIndex","modifiable"]);
const emits = defineEmits(["change"]);


const currentValue = computed ( () =>  getCurrentValue(props.value));
const canModify = computed ( () => props.modifiable ?? true);

function getCurrentValue (value)
{
    return parseInt(value);
}

function decrease ()
{
    let iValue = parseInt(currentValue.value);
    let iMin = parseInt(props.product.min ??  0);

    if (iValue > props.min)
    {
        currentValue.value = iValue = iValue - 1;
        emits("change", props.product.id, {quantity: iValue, groupIndex: props.groupIndex});
    } else {
        currentValue.value = props.min;
        emits("change", props.product.id, {quantity: parseInt(props.product.min ??  0), groupIndex: props.groupIndex});
    }


}

function increase ()
{
    let iValue = parseInt(currentValue.value);
    let iMax = parseInt(props?.product?.max ??  props.max);

    if (iValue < iMax)
    {
        currentValue.value = iValue = iValue + 1;
        emits("change", props.product.id, {quantity: iValue, groupIndex: props.groupIndex});
    }


}
function onChange ()
{
    let iValue = parseInt(currentValue.value);
    emits("change", props.product.id, {quantity: iValue, groupIndex: props.groupIndex});


}

</script>
